import { Trash2 } from "lucide-react"
import { AppDispatch, RootState } from "@/redux"
import { useDispatch, useSelector } from "react-redux"
import { Section } from "../Section"
import { InputFieldWrapper } from "../InputFieldsSection"
import { workflowActions } from "@/redux/slice/workflowSlice"
import { Button } from "@/components/ui/button"
import { useState } from "react"
import { DestinationSelectInputField } from '@/components/custom/InputField/WorkflowSelectInput'
import { ButtonVariant } from '@/constants/button/button'
import { FieldsResponse } from '@/types/WorkflowCreate/fields'
import { WFCreateStep } from '@/types/WorkflowCreate/workflowCreate'
import { Transformation } from '@/pages/Workflows/components/Modals/Transformation'
import { ActionMenu } from '@/components/custom/Table/TableActionMenu'
import { WorkflowStepType } from "@/constants/workflows/workflowCreate"

export const StepTransformation = ({
  wfStep,
  index,
}: {
  wfStep: WFCreateStep,
  index: number,
}) => {
  const dispatch: AppDispatch = useDispatch()
  const { applications } = useSelector((state: RootState) => state.application)
  const { templates } = useSelector((state: RootState) => state.transformation)
  const { create } = useSelector((state: RootState) => state.workflow)
  const [showTransformationModal, setShowTransformationModal] = useState(false)

  const menuItems = [
    {
      label: "Remove Step",
      onClick: () => dispatch(workflowActions.removeStepByStepId(wfStep)),
      disabled: false,
      icon: <Trash2 className="text-destructive" size={16} />
    },
  ];

  const getAllFields = (wfStepOrder: number) => {
    const result: Record<string, FieldsResponse> = {};

    const filteredSteps = create.steps
      .filter(step => step.order < wfStepOrder)
      .sort((a, b) => a.order - b.order);

    filteredSteps.forEach(step => {
      const app = applications.find(a => a.id === step.id);

      if (step.availableFields) {
        result[`${step.order};${app?.name || WorkflowStepType.TRANSFORMATION}`] = step.availableFields;
      }
    });

    return result;
  };

  return wfStep && (
    <Section
      key={wfStep.id + index}
      title={`Step ${index + 1}`}
      subtitle="Configure Transformation"
      description="Transform the data from previous step(s)"
    >
      <InputFieldWrapper title='Transformation' subtitle="Choose How you want to transform the data from previous step(s)">
        <div className="-mt-5 text-primary text-right">
          <ActionMenu items={menuItems} menuType='vertical' />
        </div>
        <div className='mt-4' />
        <DestinationSelectInputField
          label='Action'
          value={wfStep?.action || ''}
          selectOptions={templates.map(t => ({
            id: t.id,
            value: t.name,
            description: t.description
          }))}
          onChange={value => dispatch(workflowActions.changeStepAction({
            id: wfStep.id,
            order: wfStep.order,
            action: value
          }))}
        />
        <div className="flex justify-start mt-4">
          <Button
            type='button'
            className="w-auto font-semibold"
            variant={ButtonVariant.DEFAULT}
            onClick={() => setShowTransformationModal(true)}
            disabled={!templates.length || !wfStep.action}
          >
            Manage Transformations
          </Button>
          <Transformation
            wfStep={wfStep}
            showTransformationModal={showTransformationModal}
            setShowTransformationModal={setShowTransformationModal}
            allFields={getAllFields(wfStep.order)}
          />
        </div>
      </InputFieldWrapper>
    </Section>
  )
}
